import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import couponIcon from "../../../assets/coupon1.png"
import {  Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const CouponSection = ({
  comboCart,
  fullObjectRewardCart,
  removebtnflag,
  fetchCouponsList,
  ConformRemoveCoupon,
  RemoveCoupon,
  
  setShowCoupoListFlag,
}) => {
  const guestId = localStorage.getItem("Guest_clientId");
  const appliedCoupon = fullObjectRewardCart&&fullObjectRewardCart?.data?.reward?.couponName
  const reward=fullObjectRewardCart&&fullObjectRewardCart?.data?.reward
  // Hide coupon section if comboCart exists
  if (comboCart) return null;

  const isCouponApplied = Boolean(appliedCoupon);



 function AppliedCoupon() {
  return (
    <Box
      sx={{
        background: "#E8E2CC",
        borderRadius: "16px",
        padding: "16px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "520px"
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <CheckCircleIcon sx={{ color: "#16A34A", fontSize: 28 }} />

        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#16A34A",
              fontSize: "16px"
            }}
          >
            Applied Coupon: DTRIAL50
          </Typography>

          <Typography
            sx={{
              color: "#5f6b7a",
              fontSize: "14px"
            }}
          >
            You saved <b>₹449</b> on your final bill
          </Typography>
        </Box>
      </Stack>

      <Button
        variant="contained"
        sx={{
          background: "#18A66A",
          borderRadius: "12px",
          textTransform: "none",
          fontWeight: 600,
          padding: "6px 18px",
          "&:hover": {
            background: "#148a59"
          }
        }}
      >
        Remove
      </Button>
    </Box>
  );
}

  const getSavedAmountText = () => {
    if (!fullObjectRewardCart) return "";
    const amount =
      reward?.type === "freegift"
        ? reward?.amount
        : reward?.count;
    const unit =
      reward?.type === "cashback" || reward?.type === "freegift"
        ? "rupees on this order"
        : "on your final bill";

    return (
      <>
        You saved{" "}
        <Typography
          component="span"
          sx={{ fontWeight: 700, color: "#384F6F", fontSize: "13px" }}
        >
          ₹{amount}
        </Typography>{" "}
        {unit}
      </>
    );
  };

  return (
    <>
      {!guestId && (
        <>
          {!isCouponApplied ? (
            // ================= NO COUPON APPLIED =================
            <Card
              elevation={2}
              sx={{
                borderRadius: "10px",
                background:
                  "linear-gradient(0deg, rgba(250,225,75,0.16), rgba(250,225,75,0.16)), #fff",
                height: 63,
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="flex" alignItems="center">
                    <img
                      src={couponIcon}
                      alt="coupon"
                      style={{ width: 20, height: 20 }}
                    />
                    <Typography
                      variant="subtitle1"
                      sx={{ ml: 1, fontSize: "16px", color: "#384F6F" }}
                    >
                      Apply Coupon:
                    </Typography>
                  </Box>
                  <Typography
                    component="span"
                    sx={{
                      color: "#00B177",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={fetchCouponsList}
                  >
                    Select Coupon
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ) : (
            // ================= COUPON APPLIED =================
            <Card
            
              elevation={2}
              sx={{
                display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                borderRadius: "10px",
                background:
                  "linear-gradient(0deg, rgba(250,225,75,0.16), rgba(250,225,75,0.16)), #fff",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center">
                    <img
                      src={couponIcon}
                      alt="coupon"
                      style={{ width: 20, height: 20 }}
                    />
                   <Typography
                   style={{marginRight:"-35px"}}
            sx={{
              fontWeight: 600,
              color: "#16A34A",
              fontSize: "16px",
              ml: 1,
              
            }}
          >
            Applied Coupon: 
        
                      
                      <Typography
                        component="span"
                        sx={{
                          color: "#00B177",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          ml: 0.5,
                          fontSize: "14px",
                        }}
                      >
                        {appliedCoupon}
                      </Typography>
                    </Typography>
                  </Box>

                {/*   {removebtnflag && (
                    <Button
                      variant="text"
                      color="error"
                      size="small"
                      sx={{ textTransform: "none", fontSize: 14 }}
                      onClick={() => RemoveCoupon()}
                    >
                      Remove
                    </Button>
                  )} */}
                    {(
           /*          <Button
                      variant="text"
                      color="error"
                      size="small"
                      sx={{ textTransform: "none", fontSize: 14 }}
                     
                    >
                      Remove
                    </Button> */
                    <>
                    </>

                  )}
            
                </Box>

                <Typography
                  variant="body2"
                  sx={{ mt: 0.5, ml: 3, fontSize: 13, color: "#64748B" }}
                >
                  {getSavedAmountText()}
                </Typography>
              </CardContent>
              
<div style={{padding:"10px",    display: "flex"
    ,"align-items": "center"}}>
      
                          {<Button
                           onClick={(e) => RemoveCoupon(e,appliedCoupon)}
        variant="contained"
        sx={{
          background: "#18A66A",
          borderRadius: "12px",
          textTransform: "none",
          fontWeight: 600,

          padding: "6px 18px",
          "&:hover": {
            background: "#148a59"
          }
        }}
      >
        Remove
      </Button>}
      </div>

            </Card>
          )}
           
        </>
      )}
    </>
  );
};

export default CouponSection;
